import { useState } from "react";
import { selectorTransversal } from "../../../dtos/selector";
import { getParametrosQuery, getQuerys, getReporteCarteraTotal, getResultQuery } from "../services/servicesQuery";
import { StatusCode } from "../../../utils/enums";
import { EjecutarQueryRequestDto, ParametroConsulta } from "../models/querys";
import { AxiosResponse } from "axios";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { ValueDto } from "../../detalleMutuo/models/garantias";

export function useEjecutador() {

    const [querys, setQuerys] = useState<selectorTransversal[]>([]);
    const [queryParams, setQueryParams] = useState<ParametroConsulta[]>([]);
    const [queryTransversal, setQueryTransversal] = useState<any[]>([]);

    const getFileNameFromDisposition = (contentDisposition?: string) => {
        if (!contentDisposition) return "Reporte-Cartera-Total.xlsx";

        const fileNameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (fileNameStarMatch?.[1]) {
            return decodeURIComponent(fileNameStarMatch[1].trim().replace(/\"/g, ""));
        }

        const fileNameMatch = contentDisposition.match(/filename=([^;]+)/i);
        if (fileNameMatch?.[1]) {
            return fileNameMatch[1].trim().replace(/\"/g, "");
        }

        return "Reporte-Cartera-Total.xlsx";
    }

    const setQuerysState = async () => {

        const resp :AxiosResponse<ListResponseDto<ValueDto>>= await getQuerys();
        if (resp.status === StatusCode.Ok) {
            setQuerys(resp.data.items);
        }
    }

    const setQueryParamsState = async (idConsult: string | null) => {
        if (idConsult === null) return;

        const resp :AxiosResponse<ListResponseDto<ParametroConsulta>> = await getParametrosQuery(idConsult);
        if (resp.status === StatusCode.Ok) {
            setQueryParams(resp.data.items);
        }
    }

    const setQueryTransversalState = async (idConsult: string | null, parametros: Record<number, any>) => {
        if (idConsult === null) return;
        setQueryTransversal([]);
        const request: EjecutarQueryRequestDto = {
            id: idConsult,
            parametros: parametros,
        };
        const resp : AxiosResponse<ListResponseDto<Record<string, any>>>= await getResultQuery(request);
        if (resp.status === StatusCode.Ok) {
            setQueryTransversal(resp.data.items);
        }
    }

    const setQueryCarteraTotalState = async () => {
        setQueryTransversal([]);

        const resp: AxiosResponse<Blob> = await getReporteCarteraTotal();
        if (resp.status !== StatusCode.Ok) return;

        const contentDisposition = resp.headers?.['content-disposition'] as string | undefined;
        const fileName = getFileNameFromDisposition(contentDisposition);

        const blob = new Blob([resp.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }

    return {
        querys,
        queryParams,
        queryTransversal,
        setQuerysState,
        setQueryParamsState,
        setQueryTransversal,
        setQueryTransversalState,
        setQueryCarteraTotalState
    }
}